import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/*
 * Used to show the summary for products others than Seats. Products
 * that have a simple way to show the summary as a comma separated
 * list of items that sometimes have a quantity */
@Component({
  selector: 'fin-included-product-item-summary-checked-bag',
  templateUrl: './included-product-item-summary-checked-bag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncludedProductItemSummaryCheckedBagComponent {
  @Input()
  summary: { quantity?: number; description: string }[];
}
